// removed by extract-text-webpack-plugin
module.exports = {"toggleContainer":"filterToggle__toggleContainer--3nqKX","toggle":"filterToggle__toggle--cSJjW","valueLabel":"filterToggle__valueLabel--19S58","label":"filterToggle__label--10Q3N","dim":"filterToggle__dim--1Vsum","active":"filterToggle__active--23Q4y","radio":"filterToggle__radio--331yt","leftPosition":"filterToggle__leftPosition--2nFpx","rightPosition":"filterToggle__rightPosition--1RD6O"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/FilterComponents/filterToggle.css
// module id = kllB
// module chunks = 47